import { Tooltip } from "antd";
import { FC, ReactNode } from "react";
import { useDetailBookingStore } from "./detail-booking.store";

interface TutorialTipProps {
  text: string;
  children: ReactNode;
  placement?: "top" | "bottom" | "left" | "right" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
}

export const TutorialTip: FC<TutorialTipProps> = ({
  text,
  children,
  placement = "top",
}) => {
  const tutorialMode = useDetailBookingStore((s) => s.tutorialMode);

  if (!tutorialMode) return <>{children}</>;

  return (
    <Tooltip
      title={text}
      placement={placement}
      color="#1e40af"
      overlayInnerStyle={{ fontSize: 13, maxWidth: 280 }}
      open={undefined}
    >
      <span className="tutorial-highlight rounded transition-colors hover:bg-blue-100 hover:ring-2 hover:ring-blue-300 hover:ring-offset-1">
        {children}
      </span>
    </Tooltip>
  );
};
